// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"19c57f5b","187":"2c826f0a","457":"3f228f72","685":"702999d5"}[chunkId] + ".chunk.css";
};